import React from 'react';
import {RsnButton, RsnDialog} from '~/library/ui-kit';
import {OperableBank} from '~/redux/finances/domain';
import {FeeInfoEntry} from '../../model/FeeData';

export type PlaceholderFeeDialogProps = {
    feeInfo?: FeeInfoEntry[];
    paymentNetwork?: OperableBank.ProviderType;
    operationType: 'deposit' | 'withdraw';
};

export function PaymentSystemFeeDialog({feeInfo, paymentNetwork, operationType}: PlaceholderFeeDialogProps) {
    return (
        <RsnDialog.Window placement='center'>
            <RsnDialog.CenteredHeader>
                {paymentNetwork?.toUpperCase()} {operationType} fees
            </RsnDialog.CenteredHeader>
            <RsnDialog.Body align={'center'}>
                <div className={'flex flex-col gap-1 rounded-[10px] bg-neutral-20 p-5'}>
                    {feeInfo?.map(item => (
                        <div key={item.label} className={'fv-text-m-regular flex justify-between'}>
                            <div className={'text-left text-neutral-60'}>{item.label}</div>
                            <div className={'text-right text-neutral-90'}>{item.value}</div>
                        </div>
                    ))}
                </div>
            </RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Alike intent={'secondary'} as={RsnDialog.CloseTrigger}>
                    I got it
                </RsnButton.Alike>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
